import React from "react";
import Navbar2 from "../components/Navbar2";

const Privacy = () => {
  return (
    <section>
      <Navbar2 />

      <section className="padding ">
        <section className="md:w-[850px] w-full mx-auto  pb-[3rem]">
          <h1 className="volkhov text-center md:text-[30px] xs:text-[25px] text-[22px] xs:leading-[35px] leading-[25px] xs:pt-[20px] pt-[10px] text-tertiary">
            StarBites Application Privacy Policy
          </h1>

          <p className="xs:mt-[20px] mt-[10px] w-full inter xs:text-[16px] text-[15px] text-primary">
            Effective Date: 13th August 2024 <br /> <br />
            Starbites ("we," "our," or "us") is committed to protecting your
            privacy. This Privacy Policy explains how we collect, use, disclose,
            and safeguard your information when you use the Starbites App. By
            using the app, you agree to the terms of this Privacy Policy.
          </p>

          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            1. Information We Collect
          </h2>
          <p className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
            We may collect the following types of information when you use our
            app:
          </p>
          <ul className="xs:ml-[2rem] ml-[1rem]">
            <li className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
              <span className="font-[600] text-tertiary">
                Personal Information:
              </span>{" "}
              When you create an account or place an order, we may collect
              personal information, such as your name, email address, phone
              number, delivery address, and payment information.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              <span className="font-[600] text-tertiary">Usage Data:</span> We
              may collect information about your interactions with the app, such
              as the pages you visit, the time and date of your visit, and other
              diagnostic data.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              <span className="font-[600] text-tertiary">
                Device Information:
              </span>{" "}
              We may collect information about your device, including its model,
              operating system, and unique device identifiers.
            </li>
          </ul>

          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            2. How We Use Your Information
          </h2>
          <p className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
            We use the information we collect for various purposes, including:
          </p>
          <ul className="xs:ml-[2rem] ml-[1rem]">
            <li className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
              To provide, operate, and maintain our app.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              To process and manage your orders, payments, and deliveries.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              To communicate with you about your account or transactions.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              To improve our app, products, and services.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              To send you promotional and marketing communications (you can opt
              out at any time).
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              To detect, prevent, and address technical issues or fraudulent
              activities.
            </li>
          </ul>

          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            3. Sharing Your Information
          </h2>
          <p className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
            We may share your information with third parties in the following
            circumstances:
          </p>
          <ul className="xs:ml-[2rem] ml-[1rem]">
            <li className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
              <span className="font-[600] text-tertiary">
                Service Providers:
              </span>{" "}
              We may share your information with third-party vendors who assist
              us in providing the app, such as payment processors and delivery
              partners.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              <span className="font-[600] text-tertiary">
                Legal Requirements:
              </span>{" "}
              We may disclose your information if required to do so by law or in
              response to valid requests by public authorities.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              <span className="font-[600] text-tertiary">
                Business Transfers:
              </span>{" "}
              In the event of a merger, acquisition, or asset sale, your
              information may be transferred to the new owners.
            </li>
          </ul>

          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            4. Data Security
          </h2>
          <p className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
            We take reasonable measures to protect your information from
            unauthorized access, use, or disclosure. However, no method of
            transmission over the internet or method of electronic storage is
            100% secure.
          </p>
          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            5. Your Rights
          </h2>
          <p className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
            You have the right to:
          </p>
          <ul className="xs:ml-[2rem] ml-[1rem]">
            <li className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
              Access and review the personal information we hold about you.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              Request corrections to any inaccurate or incomplete information.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              Request deletion of your personal information, subject to legal
              obligations.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              Object to or restrict the processing of your personal information.
            </li>
          </ul>
          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            6. Third-Party Links
          </h2>
          <p className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
            Our app may contain links to third-party websites or services that
            are not operated by us. We are not responsible for the privacy
            practices of these third parties.
          </p>

          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            7. Changes to This Privacy Policy
          </h2>
          <p className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
            We may update our Privacy Policy from time to time. We will notify
            you of any changes by posting the new policy on the app. Your
            continued use of the app after any changes constitutes your
            acceptance of the revised Privacy Policy.
          </p>
          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            8. Contact Us
          </h2>
          <p className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
            If you have any questions or concerns about this Privacy Policy,
            please contact us at info@starbitesgh.com
          </p>
        </section>
      </section>
    </section>
  );
};

export default Privacy;
